module.exports = __webpack_public_path__ + "img/dental9_7-8-2021.4bf3dc98.jpg";